<template>
  <div class="spinner-box">
    <div class="btn-quarter-spinner"></div>
  </div>
</template>
